import React, { useState, useEffect } from "react";
import { Tab } from "semantic-ui-react";
import ProfilePhotos from "./ProfilePhotos";
import { Profile } from "../../app/models/Profile";
import { observer } from "mobx-react-lite";
import ProfileFollowings from "./ProfileFollowings";
import { useStore } from "../../app/stores/store";
import ProfileGames from "./ProfileGames";
import SetupProfileLocation from "./SetupProfileLocation";
import DeleteMyData from "./DeleteMyData";
import { useTranslation } from 'react-i18next';
import FavoriteSports from "./FavoriteSports";
import ProfileFriends from "./ProfileFriends";
import NotificationPreferences from "./NotificationPreferences";

interface Props{
  profile:Profile;
}

export default observer( function ProfileContent({profile}:Props) {
    const{profileStore, userStore} = useStore();
    const { t } = useTranslation();
    const [isMobile, setIsMobile] = useState(false);

    // Check if device is mobile
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        
        checkMobile();
        window.addEventListener('resize', checkMobile);
        
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    const panes = [
      {menuItem: t('profileContent.photo'), render: () => <ProfilePhotos profile={profile}/>},
      {menuItem: t('profileContent.followers'), render: () => <ProfileFollowings/>},
      {menuItem: t('profileContent.followingUsers'), render: () => <ProfileFollowings/>},
      { menuItem: t('profileContent.friends'), render: () => <ProfileFriends /> },
    ];

    // Conditionally add the location setup tab
    if (userStore.user?.userID === profile.userID) {
      panes.push(
      {
        menuItem: t('profileContent.favoriteSports'),
        render: () => <FavoriteSports />
      },  
      {
        menuItem: t('profileContent.sportEvents'),
        render: () => <ProfileGames />
      },
      {
        menuItem: t('profileContent.notifications'),
        render: () => <NotificationPreferences />
      },
      {
        menuItem: t('profileContent.setMyLocation'),
        render: () => <SetupProfileLocation />
      }
      ,
      {
        menuItem: t('profileContent.deleteMyAccount'),
        render: () => <DeleteMyData />
      }
    );
    }

    return (
      <Tab
        menu={{
          fluid: true, 
          vertical: !isMobile,
          tabular: isMobile,
          stackable: isMobile,
          widths: isMobile ? panes.length : undefined
        }}
        menuPosition={isMobile ? undefined : 'right'}
        panes={panes}
        onTabChange={(e,data) =>profileStore.setActiveTab(data.activeIndex)}
      />
    )
  }
)